import { Component, OnInit } from '@angular/core';
import { SharedDataService } from '../../all-services';

@Component({
  selector: 'app-lang-selector',
  templateUrl: './lang-selector.component.html',
  styleUrls: ['./lang-selector.component.scss']
})
export class LangSelectorComponent implements OnInit {

  frBtnImagePath: string='./assets/images/FRBtn.png';
  enBtnImagePath: string='./assets/images/ENBtn.png';
  constructor(public sharedDatasSvc: SharedDataService) { }

  ngOnInit(): void {
  }
  swithLang(e:any,lngCod: string):void{
    e.preventDefault();
    this.sharedDatasSvc.changeLanguage(lngCod);
  }

}
